export { ru } from '@payloadcms/translations/languages/ru'
